/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Not_FoundInputs */

const en_adm_err_not_found = /** @type {(inputs: Adm_Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This no longer exists. Reload the page and try again.`)
};

const de_adm_err_not_found = /** @type {(inputs: Adm_Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das gibt es nicht mehr. Lade die Seite neu und versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "This no longer exists. Reload the page and try again." |
*
* @param {Adm_Err_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_not_found = /** @type {((inputs?: Adm_Err_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_not_found(inputs)
	return en_adm_err_not_found(inputs)
});